<div class="card-body">
    <div id="client-recollection-chart"></div>
</div>